import { IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Loading from "components/Loading";
import React, { useEffect } from "react";
import { useDownloadMessageMedia } from "requests/tanstack/useDownloadMessageMedia";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import ArrowCircleDownOutlinedIcon from "@mui/icons-material/ArrowCircleDownOutlined";
import { formatBytes, handleDownloadFile } from "utils";

type Props = {
  fileUrl: string;
};

export default function FileDownloader(props: Props) {
  const { fileUrl } = props;
  const {
    data: fileData,
    isLoading: fileLoading,
    error: fileFetchError,
  } = useDownloadMessageMedia(fileUrl);

  useEffect(() => {
    return () => {
      if (fileData?.url) {
        URL.revokeObjectURL(fileData.url);
      }
    };
  }, [fileData]);

  if (fileLoading || !fileData?.url) return <Loading />;
  if (fileFetchError)
    return <p style={{ color: "red" }}>Erro ao carregar a imagem</p>;

  return (
    <Box
      bgcolor="#BDE9F0"
      display="flex"
      height="80px"
      width="100%"
      alignContent="center"
      alignItems="center"
      p={1}
      gap={2}
    >
      <InsertDriveFileOutlinedIcon color="primary" fontSize="large" />
      <Box display="flex">
        <Box alignContent="center">
          <Typography
            fontSize="0.85rem"
            fontWeight="bold"
            noWrap
            width={{ xs: "10ch", md: "15ch", lg: "20ch" }}
          >
            {fileData?.fileName || "Arquivo"}
          </Typography>
          <Typography fontSize="0.6rem">
            {fileData?.fileName?.split(".").pop()?.toUpperCase() || "ARQUIVO"} -{" "}
            {formatBytes(fileData?.size)}
          </Typography>
        </Box>
        <IconButton onClick={() => handleDownloadFile(fileData.url, "doc")}>
          <ArrowCircleDownOutlinedIcon color="primary" fontSize="large" />
        </IconButton>
      </Box>
    </Box>
  );
}
